import React from "react";
import { ApprovalPage } from "../pages/ApprovalPage";

/**
 * ApprovalsSection
 * Wrapper component for Dashboard integration
 * Renders the ApprovalPage component
 */
export const ApprovalsSection: React.FC = () => {
  return <ApprovalPage />;
};
